import BaseApi from "./BaseApi";

const baseApi = new BaseApi();

export default class WholeApp {
  Entity = "wholeApp";

  getData = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "get";
    const processedData = {
      translations: data?.translations,
      modalities: data?.modalities,
      users: data?.users,
      report_headers: data?.report_headers,
      service_code_groups: data?.service_code_groups,
      hospitals: data?.hospitals,
      department_id: data?.department_id,
	  dicom_viewers: data?.dicom_viewers,
	  configs: data?.configs,
    };

    return baseApi.fullFetch(this.Entity, action, {data: processedData});
  }
}
